<div *ngIf="isOther; else dropdownBlock">
  <app-input
    translate
    [label]="label"
    [control]="control"
    (clearEvent)="clearIsOther()"
    [clearButton]="isOther"
    [error]="error"
  ></app-input>
</div>
<ng-template #dropdownBlock>
  <mat-form-field (click)="openPanel()" (resized)="calculatePanelWidth()" appearance="standard" [ngClass]="{ 'panel-open': panelOpen, 'dropdown': true }">
    <mat-label>{{ label | translate }}</mat-label>
    <input
      #input
      translate
      type="text"
      matInput
      [formControl]="control"
      [matAutocomplete]="auto"
      matAutocompletePosition="below"
      [ngClass]="hideCaret ? 'caretTransparent' : ''"
    />
    <div matSuffix class="icon icon-dropdown"></div>
    <mat-autocomplete
      #auto="matAutocomplete"
      (closed)="handleClose()"
      [panelWidth]="length"
      (opened)="handleOpen()"
      [disableRipple]="true"
      (optionSelected)="handleOptionSelected()"
      [displayWith]="displayFn(options)"
    >
      <mat-option *ngFor="let option of options" [value]="option.value" [ngClass]="option.value === 'NOBANKOPTION' ? 'italic' : ''">
        {{ optionsTranslationKey + '.' + option.display | translate }}
      </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="error">
      {{ error }}
    </mat-error>
  </mat-form-field>
</ng-template>
